export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            关于我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500">了解7777影院的故事</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden bg-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20cinema%20room%20with%20comfortable%20seating%20and%20large%20projection%20screen%2C%20soft%20ambient%20lighting%20with%20warm%20golden%20tones%2C%20movie%20posters%20on%20wall%2C%20popcorn%20bowl%2C%20intimate%20viewing%20atmosphere%2C%20cinematic%20interior%20design%2C%20no%20people%2C%20editorial%20lifestyle%20photography&width=600&height=600&seq=about-cinema-2026&orientation=squarish"
                  alt="7777影院 — 关于我们"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="font-heading font-semibold text-xl text-foreground-900 mb-4">
                让每个人都能轻松看电影
              </h3>
              <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                <p>
                  7777影院成立于2024年，由一群热爱影视的年轻人创立。我们的使命很简单：让每个人都能轻松找到并观看自己想看的影视内容，无论是最新上映的电影，还是经典老剧，都能在这里一站搞定。
                </p>
                <p>
                  我们坚持每日更新片库，精心筛选优质内容，确保每一部上线作品都是高清画质、流畅播放。从院线大片到小众佳作，从国产热剧到海外精品，7777影院致力于打造最全、最快、最好的免费影视平台。
                </p>
                <p>
                  目前平台已积累12000+部影视资源，覆盖电影、电视剧、综艺、动漫、纪录片等多个品类，日均服务数百万影视爱好者。未来我们将继续扩充内容、优化体验，让追剧观影变得更简单、更快乐。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}